export const PRODUCT_GROUPS_LOAD = 'PRODUCT_GROUPS_LOAD'
export const productGroupsLoad = (
  accountId: string,
  projectId: string
): ProductGroupsLoadAction => ({
  type: PRODUCT_GROUPS_LOAD,
  accountId,
  projectId
})

export const PRODUCT_GROUPS_LOAD_SUCCESS = 'PRODUCT_GROUPS_LOAD_SUCCESS'
export const productGroupsLoadSuccess = (
  accountId: string,
  projectId: string,
  productGroups: any[]
): ProductGroupsLoadSuccessAction => ({
  type: PRODUCT_GROUPS_LOAD_SUCCESS,
  accountId,
  projectId,
  productGroups
})

export const PRODUCT_GROUPS_LOAD_FAIL = 'PRODUCT_GROUPS_LOAD_FAIL'
export const productGroupsLoadFailure = (
  accountId: string,
  projectId: string,
  error
): ProductGroupsLoadFailAction => ({
  type: PRODUCT_GROUPS_LOAD_FAIL,
  accountId,
  projectId,
  error
})

// INTERFACEs
export interface ProductGroupsLoadAction {
  type: typeof PRODUCT_GROUPS_LOAD
  accountId: string
  projectId: string
}

interface ProductGroupsLoadSuccessAction {
  type: typeof PRODUCT_GROUPS_LOAD_SUCCESS
  accountId: string
  projectId: string
  productGroups: any[]
}

interface ProductGroupsLoadFailAction {
  type: typeof PRODUCT_GROUPS_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}
